'use client';
import { useState } from 'react';

const ChatIcon = () => {
  const [iconColor, setIconColor] = useState('url(#paint0_linear_0_253)');

  const handleMouseEnter = () => {
    setIconColor('#FFFFFF');
  };

  const handleMouseLeave = () => {
    setIconColor('url(#paint0_linear_0_253)');
  };

  const handleClick = () => {
    setIconColor('#064E3B');
    setTimeout(() => {
      window.open('https://chat.yourdomain.com', '_blank', 'noopener,noreferrer');
    }, 500);
  };

  return (
    <div
      className="ml-3 group cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-colors duration-200"
      >
        <path
          d="M21.0803 12.9207C20.4803 17.5107 15.9403 21.2307 11.3103 21.2307H4.64034C4.07421 21.2309 3.54956 20.9338 3.25859 20.4482C2.96762 19.9625 2.9531 19.3598 3.22034 18.8607L3.49034 18.3507C3.78034 17.8568 3.78034 17.2446 3.49034 16.7507C1.21738 13.1602 1.5724 8.50324 4.36334 5.29882C7.15428 2.09439 11.7184 1.10342 15.5869 2.86195C19.4554 4.62047 21.7097 8.71094 21.1303 12.9207H21.0803Z"
          fill={iconColor}
        />
        <defs>
          <linearGradient
            id="paint0_linear_0_253"
            x1="2"
            y1="11.5332"
            x2="21.2205"
            y2="11.5332"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#27FF7D" />
            <stop offset="1" stopColor="#18994B" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default ChatIcon;
